import { useMutation, useQuery } from '@tanstack/react-query';

import { TermsAndConditionsResponse } from '../models/TermsAndConditionsResponse';
import axios from 'axios';
import axiosClient from '../axiosBearerClient';

export const useGetPublicTermsAndConditions = () => {
  const { isFetching, error, data, isError, refetch } = useQuery({
    queryKey: ['public-terms-and-conditions'],
    gcTime: 0,
    enabled: false,
    retry: false,
    queryFn: async () => {
      try {
        const response =
          await axiosClient.get<TermsAndConditionsResponse>(`/terms-conditions/signup`);
        if (response.data.uri && response.data.accepted === false) {
          return await axios.get<string>(response.data.uri);
        }
      } catch (err) {
        throw new Error('Unable to get Terms and conditions');
      }
    },
  });

  return {
    isFetching,
    error,
    isError,
    data,
    refetch,
  };
};

export const useGetTermsAndConditions = () => {
  const { isFetching, error, data, isError, refetch } = useQuery({
    queryKey: ['terms-and-conditions'],
    gcTime: 0,
    enabled: true,
    retry: false,
    queryFn: async () => {
      try {
        const response = await axiosClient.get<TermsAndConditionsResponse>(`/terms-conditions`);
        if (response.data.uri && response.data.accepted === false) {
          return await axios.get<string>(response.data.uri);
        }
        return Promise.resolve(null);
      } catch (err) {
        throw new Error('Unable to get new  Terms and conditions');
      }
    },
  });

  return {
    isFetching,
    error,
    isError,
    data,
    refetch,
  };
};

export const useAcceptTermsAndConditions = () => {
  const { isPending, error, data, isError, mutateAsync } = useMutation({
    retry: false,
    mutationFn: async () => {
      return await axiosClient.put<boolean>(`/terms-conditions/accept`);
    },
  });

  return {
    isPending,
    error,
    isError,
    data,
    mutateAsync,
  };
};
